module.exports = function (app) {
    "use strict";

    app.directive('formValidationGenerator', function ($compile, $timeout) {

        /*
         Make sure to name your inputs/selects/textareas if you want this form to create hmhs validation for you.
         i.e. name="insuranceCarrier_{{$index}}"

         */
        return {
            priority: 50,
            restricted: "A",
            replace: false,
            require: "form",
            link: function (scope, element, attribute, ctrl) {

                var form = ctrl;

                var ngMessageBuilder = function (validators, inputEl) {
                    var defaultMessages = {
                        required: '<span data-ng-message="required">This field is required</span>',
                        minlength: '<span data-ng-message="minlength">Too Short. ' + ( inputEl.attributes.minlength && inputEl.attributes.minlength.value || '') + ' Character minimum.</span>',
                        maxlength: '<span data-ng-message="maxlength">Too Long. ' + ( inputEl.attributes.maxlength && inputEl.attributes.maxlength.value || '') + '  Character maximum exceeded</span>',
                        email: '<span data-ng-message="email">A valid email address is required. Ensure common email formats are followed, such as an @ symbol </span>',
                        date: '<span data-ng-message="date">This is not a valid date</span>',

                        min: '<span data-ng-if="!plan.spa" data-ng-message="min">This date comes before allowed date range</span>' +
                                '<span data-ng-if="plan.spa" data-ng-message="min">The date entered must be within the selected Plan Period and End Date must be greater than Begin Date.</span>',

                        max: '<span data-ng-if="!plan.spa" data-ng-message="max">This date comes after allowed date range</span>' +
                                '<span data-ng-if="plan.spa" data-ng-message="max">The date entered must be within the selected Plan Period and End Date must be greater than Begin Date.</span>',


                        mask: '<span data-ng-message="mask">Please complete field correctly.</span>',
                        coverage: '<span data-ng-message="coverage">Subscriber must be selected for plan if dependent is selected.</span>',
                        pattern: '<span data-ng-message="pattern">Please enter the value in a valid format</span>'



                    };

                    var messages = [];

                    for (var i = 0; i < validators.length; i++) {
                        if (defaultMessages[validators[i]]) {
                            messages.push(defaultMessages[validators[i]]);
                        }
                    }
                    if (inputEl.type === 'date') {
                        messages.push(defaultMessages[inputEl.type]);
                    }
                    return messages.join('');
                };

                var setValidationHtml = function (nestedForm) {


                    var iterateForm = nestedForm || form;

                    //Timeout makes sure all other directives have loaded before running these inserts.
                    $timeout(function () {

                        angular.forEach(form, function (input) {

                            if (input && input.$name && !input.$$parentForm) {
                                //if (input && input.$name) {
                                var inputName = input.$name;

                                var targetEl = {};
                                var inputEl = angular.element('[name=' + inputName + ']');
                                var inputLabel = inputEl.parent('label');

                                //If input has a label, and not a radio button.
                                if (inputLabel[0] && inputEl[0] && inputEl[0].type !== 'radio' && inputEl[0].type !== 'checkbox') {
                                    if (!inputLabel.next('.validationErrorContainer')[0]) {
                                        targetEl = inputLabel.children('').last().not('.validationErrorContainer');
                                    }
                                } else
                                //If Radio or checkbox, then get the closest fieldset to place the validation after.
                                if (inputEl[0] && inputEl[0].type && (inputEl[0].type === 'radio' || inputEl[0].type === 'checkbox')) {
                                    //    find FieldSet, apply to that thing.

                                    targetEl = inputEl.closest('fieldset').children().last().not('.validationErrorContainer');

                                } else {
                                    //if you can't find any of these other options, then just place immediately after input.
                                    if (!inputEl.next('.validationErrorContainer')[0]) {
                                        targetEl = inputEl;
                                    }
                                }

                                if (targetEl[0] && inputName && iterateForm[inputName] && Object.keys(iterateForm[inputName].$validators).length > 0) {

                                    var validators = Object.keys(iterateForm[inputName].$validators);


                                    //var domElement = input; //element.find('[name=' + input.$name + ']')[0];
                                    var template = angular.element('<div data-form="' + iterateForm.$name + '"data-validation="' + iterateForm.$name + '.' + inputName + '">' + ngMessageBuilder(validators, inputEl[0]) + '</div>');

                                    $compile(template)(scope, function (clonedElement, scope) {
                                        clonedElement.insertAfter(targetEl);
                                    });
                                }
                            }
                        });
                    }, 0);
                };


                // Initialize and Watch

                setValidationHtml();

                scope.$watchCollection(function () { return form}, function (newData, oldData) {

                    if (newData !== oldData) {
                        setValidationHtml();
                    }

                });
            }
        };
    });
}
